import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '../../../../button/button.component';
import { AppService } from '../../../../../services/app.service';
import { AsyncPipe } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-book-shelf-drawer-bean-prompt',
  templateUrl: './book-shelf-drawer-bean-prompt.component.html',
  styleUrl: './book-shelf-drawer-bean-prompt.component.scss',
  imports: [ButtonComponent, AsyncPipe],
})
export class BookShelfDrawerBeanPromptComponent {
  @Input({ required: true }) beanLabel!: string;
  @Input({ required: true }) buttonLabel!: string;
  @Output() buttonClicked: EventEmitter<number> = new EventEmitter<number>();

  constructor(public appService: AppService) {}
}
